/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

export class NumberUtils {

  public static formatNumberWithDecimals(value: any, numberOfDecimals = 2): number {
    if (value) {
      return Number(parseFloat(value).toFixed(numberOfDecimals));
    }
    return 0;
  }

  public static sumWithPrecision(a: number, b: number, precision = 2): number{
    const factor = Math.pow(10, precision);
    return (this.formatNumberWithDecimals(a, precision) * factor + this.formatNumberWithDecimals(b, precision) * factor) / factor;
  }
}
